<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">        
      
      <el-form :inline="true" class="backborder1 demo-form-inline" ref="query" :model="query" size="small">
          <el-form-item>
              <el-input placeholder="请输入关键字" v-model="query.key" clearable @keyup.enter.native="getlists" @change="queryselect=true"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getlists">查询</el-button>
              <el-button type="primary" icon="el-icon-search" @click="catemanage">分类绑定标签管理</el-button>
              <el-button type="danger" icon="el-icon-plus" @click="addlabel">新增</el-button>
          </el-form-item>
      </el-form>
      
      <div class="backborder2" style="margin-top:10px">
	      <el-table :data="lists" v-loading="listsloading">
	            <el-table-column prop="name" label="标签名称"></el-table-column>
	            <el-table-column label="子标签" align="left" width="450">
		            <template slot-scope="scope">
		            	<el-tag type="success" v-for="(item,index) in scope.row.childname" :key="index" v-if="scope.row.childids!=''" style="margin:0 10px 10px 0">{{item}}</el-tag>
		            </template>
	            </el-table-column>
	            <el-table-column prop="catnums" label="绑定分类数量" width="120" align="center"></el-table-column>
	            <el-table-column prop="goodsnums" label="绑定商品数量" width="120" align="center"></el-table-column>
	            <el-table-column label="排序" align="center" width="100">
		            <template slot-scope="scope">
		            	<el-input placeholder="请输入关键字" v-model="scope.row.sort"  @blur="changesort(scope.row)"></el-input>
		            </template>
	            </el-table-column>
	            <el-table-column label="操作" width="200" align="center">
		            <template slot-scope="scope">
						<!--
						<el-button type="primary" size="small" icon="el-icon-document" circle @click="showcontactcate(scope.row)"></el-button>
						<el-button type="warning" size="small" icon="el-icon-document" circle @click="showcontactgoods(scope.row)"></el-button>
		                -->
						<el-button type="warning" size="small" icon="el-icon-edit" circle @click="editCurrent(scope.row)"></el-button>
		                <el-button type="danger" size="small" icon="el-icon-delete" circle @click="del(scope.row)"></el-button>
		            </template>
	            </el-table-column>	          	            
	      </el-table>
	      <div class="block">
	      	  <!--分页begin-->
	          <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="listrow">
	          </el-pagination>
	          <!--分页end-->
	      </div>
      </div>
      
      <!----------- 新增标签信息 -------------->
      <el-dialog title="新增标签信息" :visible.sync="addDialog" width="20%" top="25vh">
      	  <el-form :inline="true" size="small">
      	  	  <el-col :span="24">
	      	  	  <el-form-item style="width:100%">
		              <el-input placeholder="请输入标签名" v-model="create.name" clearable></el-input>
		          </el-form-item>
	          </el-col>
	          <el-col :span="24">
		          <el-form-item style="width:100%">
		              <el-select v-model="create.cateid" filterable clearable placeholder="请选择分类（默认为顶级）">
		              	  <el-option label="顶级分类" value="0" :key="index"></el-option>
		              	  <el-option v-for="(item,index) in catelists" :label="item.name" :value="item.id" :key="index"></el-option>
		              </el-select>
		          </el-form-item>
	          </el-col>
      	  </el-form>
      	  <div slot="footer" class="dialog-footer">
      	  	  <el-button @click="addDialog=false" size="small">取消</el-button>
      	  	  <el-button type="primary" @click="addcreate" size="small" :loading="addLoading">确定</el-button>
      	  </div>
      </el-dialog>
      
      <!----------- 编辑标签信息 -------------->
      <el-dialog title="编辑标签信息" :visible.sync="updateDialog" width="20%" top="25vh">
      	  <el-form :inline="true" size="small">
      	  	  <el-col :span="24">
	      	  	  <el-form-item style="width:100%">
		              <el-input placeholder="请输入标签名" v-model="update.name" clearable></el-input>
		          </el-form-item>
	          </el-col>
	          <el-col :span="24">
		          <el-form-item style="width:100%">
		              <el-select v-model="update.catid" filterable clearable placeholder="请选择分类（默认为顶级）">
		              	  <el-option label="顶级分类" value="0" :key="index"></el-option>
		              	  <el-option v-for="(item,index) in catelists" :label="item.name" :value="item.id" :key="index"></el-option>
		              </el-select>
		          </el-form-item>
	          </el-col>
      	  </el-form>
      	  <div slot="footer" class="dialog-footer">
      	  	  <el-button @click="updateDialog=false" size="small">取消</el-button>
      	  	  <el-button type="primary" @click="saveupdate" size="small" :loading="updateLoading">确定</el-button>
      	  </div>
      </el-dialog>
      
      
  </div>
  </transition>   
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Labelsetting/index",
      transitionshow:true,
      listsloading:false,
      lists:[],
      listrow:0,
      queryselect:false,
      query: {
      	  act:'lists',
      	  token:this.$cookies.get('token'),
      	  key:'',
      	  p:1,
      	  rollpage:10,
      },
      catequery: {
      	  act:'getcatelists',
      	  parentid:'a0',
		  token:this.$cookies.get('token'),
      },
      catelists:[],
      
      addDialog:false,
      addLoading:false,
      create: {
      	  act:'addlabel',
      	  token:this.$cookies.get('token'),
      	  name:'',
      	  cateid:'0'
      },
      updateDialog:false,
      updateLoading:false,
      update: {
      	  act:'updatelabel',
      	  token:this.$cookies.get('token'),
      	  id:'',
      	  name:'',
      	  catid:'',
      },
      
	  contactcateDialog:false,
	  contactloading:false,
	  contactquery: {
      	  act:'getcontactcate',
      	  token:this.$cookies.get('token'),
      	  labelid:'',
      	  key:'',
		  p:1,
		  rollpage:10
      },
	  contactcatelists:[],
	  contactrows:0,
      
    }  
  },
  mounted(){
  	 //获取标签信息列表
     this.getlists();
     //获取标签分类列表
     this.getcatelists(); 
  },
  methods:{
  
  	  //获取分类列表
  	  getcatelists() {
  	  	  var resource = this.$resource(this.url);
          resource.query(this.catequery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.catelists=JSON.parse(Base64.decode(res.data.Data));
              }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
          }); 
  	  },
    	  
      //获取标签信息列表
      getlists() {
      	  if(this.queryselect==true) {
      	  	  this.query.p=1;
      	  	  this.query.rollpage=10;
      	  }
      	  this.listsloading=true;
      	  var resource = this.$resource(this.url);
          resource.query(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.listsloading=false;
              }else{
                  this.lists=JSON.parse(Base64.decode(res.data.Data));
                  this.listrow=parseInt(res.data.count);
                  this.listsloading=false;
                  if(this.queryselect==true) this.queryselect=false;
              }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
              this.listsloading=false;
          }); 
      },
      
      pageSizeChange(val) {
          this.query.rollpage = val;
          this.getlists();
      },
      pageCurrentChange(val) {
          this.query.p = val;
          this.getlists();
      }, 	   
       
    	  
  	  //新增标签
  	  addlabel() {
      	  this.create.name='';
      	  this.create.cateid='0';
  	  	  this.addDialog=true;
  	  },
  	  
  	  //保存标签信息
  	  addcreate() {
  	  	  this.addLoading=true;
  	  	  var resource = this.$resource(this.url);
          resource.save(this.create).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.addLoading=false;
              }else{
                  this.$message.success('添加商品到专区成功!');
                  this.addLoading=false;
                  this.addDialog=false;
                  this.getcatelists(); 
              }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
              this.addLoading=false;
          });  	
  	  },
  	  
  	  //修改标签排序
  	  changesort(item) {
  	  	  var resource = this.$resource(this.url);
          resource.save({act:'changesort',token:this.$cookies.get('token'),id:item.id,sort:item.sort}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.getcatelists(); 
              }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
          }); 
  	  },
  	  
  	  //管理标签分类
  	  catemanage(item) {
  	  	  this.$emit('listenchild',{name:"分类绑定标签管理",url:'Labelandcatid'});
  	  },
  	  
  	  //删除标签信息
  	  del(item) {
			var result;
			var resource = this.$resource(this.url);
			resource.save({act:'dellabelbefore',token:this.$cookies.get('token'),id:item.id}).then((res) => {
			     if(res.data.Result>0){
			         if(res.data.Result=='70001') this.$router.push('/login')
			         this.$message.error(res.data.Message);
			     }else{
			         result=JSON.parse(Base64.decode(res.data.Data));
					 this.$confirm(result.msg, '提示', { type: 'warning' }).then(() => {        	
					 	resource.save({act:'delsinglelabel',token:this.$cookies.get('token'),id:item.id}).then((res) => {
							if(res.data.Result>0){
								if(res.data.Result=='70001') this.$router.push('/login')
								this.$message.error(res.data.Message);
							}else{
								this.$message.success('删除标签信息成功!');
								this.getlists();
							}
						}).catch((res) => {
						
						});
					
				}).catch(() => {
					
				});

			     }
		     }).catch((res) => {
		          
		     });
  	  },
  	  
  	  //编辑标签信息
  	  editCurrent(item) {
  	  	  this.update.id=item.id;
      	  this.update.name='';
      	  this.update.catid='';
      	  
      	  var resource = this.$resource(this.url);
          resource.save({act:'getlabelinfos',token:this.$cookies.get('token'),id:item.id}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  var data=JSON.parse(Base64.decode(res.data.Data));
                  this.update.name=data.name;
                  this.update.catid=data.parentid;
                  this.updateDialog=true;
              }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
          }); 
  	  },
  	  
  	  //保存修改的标签信息
  	  saveupdate() {
      	  this.updateLoading=true;
      	  var resource = this.$resource(this.url);
          resource.save(this.update).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.updateLoading=false;
              }else{
                  this.$message.success("标签信息更新成功！");
                  this.updateDialog=false;
                  this.updateLoading=false;
                  //获取标签信息列表
			      this.getlists();
			      //获取标签分类列表
			      this.getcatelists();                   
              }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
              this.updateLoading=false;
          }); 
  	},

	//获取标签绑定的分类列表
	showcontactcate(item) {
		this.contactcateDialog=true;
		this.contactquery.labelid=item.id;
		this.contactquery.key='';
		this.contactquery.p=1;
		this.contactquery.rollpage=10;
		this.getcontactcatelists();
	}, 

	getcontactcatelists() {
		this.contactloading=true;
		var resource = this.$resource(this.url);
          resource.query(this.contactquery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.contactloading=false;
              }else{
                  this.contactcatelists=JSON.parse(Base64.decode(res.data.Data));
                  this.contactrows=parseInt(res.data.count);
                  this.contactloading=false;
              }
        }).catch((res) => {
              this.contactloading=false;
    	}); 
	}
  	  
  	  
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/mall/Labelsetting.vue